import { render, staticRenderFns } from "./product_info.vue?vue&type=template&id=6ea709dc&scoped=true"
import script from "./product_info.vue?vue&type=script&lang=js"
export * from "./product_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea709dc",
  null
  
)

export default component.exports